import React from 'react';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { REASONS_LIST } from './constants';
import classes from './index.module.scss';

const WhyUseLogoMaker = () => (
    <section className={classes.wrapper}>
        <div className={classes.thinContainer}>
            <h2 className={classes.title}>
                <I18n k="makers_experience_perseus.buyer_landing_page.why_use_logo_maker.section_title" />
            </h2>
            <p className={classes.subtitle}>
                <I18n k="makers_experience_perseus.buyer_landing_page.why_use_logo_maker.section_subtitle" />
            </p>
        </div>
        <div className={classes.container}>
            <div className={classes.reasons}>
                {REASONS_LIST.map(({ alt, body, title, illustration }) => (
                    <div className={classes.reason} key={title}>
                        <div className={classes.illustration}>
                            <img
                                alt={translate(alt)}
                                className={classes.illustrationImage}
                                width={illustration.width}
                                height={illustration.height}
                                src={illustration.src}
                                loading="lazy"
                            />
                        </div>
                        <h3 className={classes.reasonTitle}>
                            <I18n k={title} />
                        </h3>
                        <p className={classes.description}>
                            <I18n k={body} />
                        </p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default WhyUseLogoMaker;
